import React, { useMemo } from 'react';
import { useTranslate } from 'react-admin';
import { useApiLocalization } from '~/hooks/useApiLocalization';
import AutocompleteInput from '~/components/AutocompleteInput';
import { isEmpty } from 'lodash';

interface Props {
  onChange: (e: any) => void;
  value: string | undefined;
  name?: string; // In case if needed
  label?: string; // In case if needed
  [x: string]: any;
}

const OperationSubtypeInput = (props: Props) => {
  const { onChange, value, name, label } = props;
  const translate = useTranslate();
  const t = (key: string): string => translate(`resources.headTransactions.list.filters.${key}`);

  const { data: translations } = useApiLocalization('operationSubtype');
  const choices = useMemo(() => {
    return translations && !isEmpty(translations)
      ? Object.entries(translations).map(([key, value]) => {
          const shortKey = key.startsWith('operationSubtype.')
            ? key.replace('operationSubtype.', '')
            : key;
          return { value: shortKey, text: shortKey, label: `${value} (${shortKey})` };
        })
      : [];
  }, [translations]);

  return (
    <AutocompleteInput<string | undefined>
      options={choices}
      label={label || t('operationSubtype')}
      value={value}
      onInputChange={(_, value) => {
        onChange?.({ target: { name, value } });
      }}
      renderOption={(option) => <div>{option?.label}</div>}
      className={props.className}
      allowEmpty
      disableHelperText
    />
  );
};

export default OperationSubtypeInput;
